export default __webpack_public_path__ + "static/media/853.1b06e361.png";